// // src/api/usercenterApi.js
// import service from "./axiosConfig";
// src/api/userApi.js
import apiClient from "./axiosConfig";
// import { useAuthStore } from "@/store/authStore"; // 根据你的实际路径调整

// 添加请求拦截器
apiClient.interceptors.request.use(
  (config) => {
    console.log("请求拦截器触发"); // 调试：拦截器触发
    // 直接从 localStorage 获取 token
    const authData = localStorage.getItem("auth");
    // console.log("authData:", authData); // 调试：authData 内容

    // 如果 token 存在，添加到请求头
    if (authData) {
      try {
        // 解析存储的认证数据
        const storedAuth = JSON.parse(authData);
        // console.log("storedAuth:", storedAuth); // 调试：storedAuth 内容
        // 关键修改：处理Pinia的存储结构
        const authState = storedAuth.state || storedAuth;
        const token = authState._token; // 直接访问_token属性
        // console.log("token:", token); // 调试：token 内容
        if (token) {
          config.headers["token"] = `${token}`;
          // console.log("Authorization header:", config.headers.Authorization); // 调试：Authorization header
        }
      } catch (e) {
        console.error("解析 auth 状态失败", e);
      }
    }

    return config;
  },
  (error) => {
    // 对请求错误做些什么
    return Promise.reject(error);
  }
);

/**
 *  @param {string} [token] - 可选的 token，如果传入则优先使用此 token
 */
export const getUserInfo = async (params) => {
  try {
    // 从 localStorage 获取令牌（用于请求体）
    const response = await apiClient.post(
      "/interface/school/getfrontusers",
      params
    );

    if (response.data.code === 200) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error: response.data.msg || "获取用户信息失败",
      };
    }
  } catch (error) {
    console.error("获取用户信息时发生错误:", error);
    return {
      success: false,
      error: error.message || "网络错误，请重试",
      code: response.data.code, // 添加错误代码
    };
  }
};
/**
 * 更新用户信息
 * @param userData - 需要更新的用户数据（nickName, phonenumber, email, sex）
 */
export const updateUserInfo = async (userData) => {
  try {
    // 从 localStorage 获取 token 或其他方式传入
    // console.log("-----------------");
    // console.log(userData);
    const response = await apiClient.post("/interface/user/edituserinfo", {
      ...userData,
    });

    if (response.data.code === 200) {
      return {
        success: true,
        data: response.data.data,
      };
    } else {
      return {
        success: false,
        error: response.data.msg || "更新用户信息失败",
      };
    }
  } catch (error) {
    console.error("更新用户信息时发生错误:", error);
    return {
      success: false,
      error: error.message || "网络错误，请重试",
    };
  }
};
/**
 * 修改用户密码
 * @param {Object} payload 包含 oldPassword, newPassword
 */

export const changePassword = async (params) => {
  console.log("发送的参数:", params); // 调试：查看实际发送的数据
  try {
    const response = await apiClient.post(
      "/interface/user/editpassword",
      params
    );
    if (response.data.code === 200) {
      return { success: true, msg: "密码修改成功" };
    } else {
      return { success: false, msg: response.data.msg || "修改失败" };
    }
  } catch (error) {
    console.error("修改密码失败:", error);
    return { success: false, msg: "网络错误，请重试" };
  }
};
